import { Create, PasswordInput, SimpleForm, TextInput } from "react-admin";

const CashierCreate = () => {
  return (
    <Create
      transform={(data) => ({
        ...data,
        role: "4",
      })}
    >
      <SimpleForm>
        <TextInput source="full_name" label="ra.users.fullName" />
        <TextInput source="pseudo" label="ra.users.pseudo" />
        <PasswordInput source="password" label="Password" />
        <TextInput source="email" label="ra.users.mail" />
      </SimpleForm>
    </Create>
  );
};

export default CashierCreate;
